import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from '../Logo';

export default function HammerNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="hammer-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-black/80 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <Logo />

        <div className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/"
            data-testid="hammer-nav-back-to-barges"
            className="inline-flex items-center gap-1.5 sm:gap-2 text-[11px] sm:text-[12px] font-medium tracking-[0.16em] sm:tracking-[0.18em] uppercase text-zinc-300 hover:text-cyan-300 transition-colors whitespace-nowrap"
          >
            <ArrowLeft className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            <span className="hidden sm:inline">Absolute Barges</span>
            <span className="sm:hidden">Barges</span>
          </Link>
          <a
            href="#hammer-quote"
            data-testid="hammer-nav-buy-btn"
            className="btn-teal px-4 py-2 rounded-md text-xs sm:text-sm uppercase tracking-[0.14em]"
          >
            Buy — $10,500*
          </a>
        </div>
      </div>
    </header>
  );
}
